import * as React from 'react';
import { connect } from 'react-redux';
import { Card, Form, Notification } from '../';
import { returnBooking } from '../../redux/actions/bookings';

interface Props {
  id: number;
  dispatch: Function;
  handleSubmit: Function;
  mileageBefore: number;
}

interface State {
  isRequesting: boolean;
  errorMessage: string | boolean;
}

class BookingReturnForm extends React.Component<Props, State> {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.state = {
      isRequesting: false,
      errorMessage: false,
    };
  }

  async handleSubmit(data) {
    if (!window.confirm('Are you sure you want to return this booking?')) {
      return;
    }
    this.setState({ isRequesting: true, errorMessage: false });
    const { error } = await this.props.dispatch(
      returnBooking(this.props.id, data),
    );
    if (error) {
      this.setState({
        errorMessage: error,
        isRequesting: false,
      });
      return;
    }
    this.props.handleSubmit();
  }

  render() {
    return (
      <>
        <Card>
          <div className="field">
            <label className="label">Mileage Before</label>
            <input
              className="input"
              disabled
              value={this.props.mileageBefore}
            />
          </div>
          <Form
            type="booking_return_form"
            buttonText="Return Booking"
            handleSubmit={this.handleSubmit}
            disabled={this.state.isRequesting}
            fields={[
              {
                label: 'Mileage Afterwards',
                name: 'mileage_after',
                type: 'number',
              },
            ]}
          />
        </Card>
        {this.state.errorMessage && (
          <Notification type="danger">{this.state.errorMessage}</Notification>
        )}
      </>
    );
  }
}

export default connect()(BookingReturnForm);
